<template>
  <nav class="menu-container">
    <h3><font color="#168773">6号线支线</font></h3>
    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
  </nav>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  data() {
    return {
      items: [
        {
          name: "guangming",
          title: "光明",
          // icon: "chat",
          exact: true,
        },
        {
          name: "zhenmei",
          title: "圳美",
          // icon: "chat",
          exact: true,
        },
        {
          name: "zhongda",
          title: "中大",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shenligong",
          title: "深理工",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(67, 47, 221);
    }
  }
}
</style>


